import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';


const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  alertIcon: {
    textAlign: 'center'
  }
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <h2 className="s-page-tit">{children}</h2>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '14px 40px',
    minHeight: 80,
    fontSize: 16,
    fontWeight: 'normal',
    textAlign: 'center'
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '0px 40px 40px 40px',
  },
}))(MuiDialogActions);

export default function CustomizedDialog(props) {
  //const [open, setOpen] = React.useState(props.open);
  const { children } = props;
  /* const handleClickOpen = () => {
    setOpen(true);
  }; */
  /* const handleClose = () => {
    setOpen(false);
    props.stateRefresh();
  }; */

  return (
    <>
      <Dialog className="dialog-wrapper" fullScreen={props.isFullScreen} scroll={'paper'} fullWidth={true} onClose={props.handleClose} aria-labelledby="customized-dialog-title" open={props.open}>
        {props.title && 
          <DialogTitle className="dialog-title text-align-center" id="customized-dialog-title" onClose={props.handleClose}>
            { props.title }
          </DialogTitle>
        }
        <DialogContent>
          {React.cloneElement(children)}
        </DialogContent>
        {props.actionPane &&
          <DialogActions>
            {props.actionPane}
          </DialogActions>
        }
      </Dialog>
    </>
  );
}